import { GET_REWARDS } from '../Actions/actionTypes';
export default (state={},action)=>{
  switch(action.type){
    case GET_REWARDS:
      return action.payload;
    default:
      return state;
  }
}